import { Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import * as i0 from "@angular/core";
var StorageService = /** @class */ (function () {
    function StorageService() {
        this.onSubject = new Subject();
        this.changes = this.onSubject.asObservable().pipe(share());
        this.currentStorage = sessionStorage;
        this.currentStorageLocal = localStorage;
    }
    Object.defineProperty(StorageService.prototype, "storage", {
        set: function (storage) {
            this.currentStorage = storage;
        },
        enumerable: true,
        configurable: true
    });
    StorageService.prototype.getStorage = function () {
        var s = [];
        for (var i = 0; i < this.currentStorage.length; i++) {
            s.push({
                key: this.currentStorage.key(i),
                value: JSON.parse(this.currentStorage.getItem(this.currentStorage.key(i)))
            });
        }
        return s;
    };
    StorageService.prototype.getItem = function (key) {
        var val = this.currentStorage.getItem(key);
        return val ? JSON.parse(val) : null;
    };
    StorageService.prototype.getItemPlain = function (key) {
        return this.currentStorage.getItem(key);
    };
    StorageService.prototype.getItemLocalPlain = function (key) {
        return this.currentStorageLocal.getItem(key);
    };
    StorageService.prototype.store = function (key, data) {
        this.currentStorage.setItem(key, JSON.stringify(data));
        // the local application doesn't seem to catch changes to localStorage...
        this.onSubject.next({ key: key, value: data });
    };
    StorageService.prototype.storePlain = function (key, data) {
        this.currentStorage.setItem(key, data);
        // the local application doesn't seem to catch changes to localStorage...
        this.onSubject.next({ key: key, value: data });
    };
    StorageService.prototype.storeLocalPlain = function (key, data) {
        this.currentStorageLocal.setItem(key, data);
    };
    StorageService.prototype.clear = function (key) {
        this.currentStorage.removeItem(key);
        // the local application doesn't seem to catch changes to localStorage...
        this.onSubject.next({ key: key, value: null });
    };
    StorageService.prototype.clearLocal = function (key) {
        this.currentStorageLocal.removeItem(key);
        // the local application doesn't seem to catch changes to localStorage...
        this.onSubject.next({ key: key, value: null });
    };
    StorageService.ngInjectableDef = i0.defineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
export { StorageService };
